<template>
  <div :class="[cssPrefix]">
    <div class="theme" :class="getActiveTheme">
      <error-page v-if="error" :error="error"/>
      <emat-loader v-else-if="loading" :loading="loading" :global="true"/>
      <template v-else>

        <div class="info-banner" @click="confirmLeave" v-if="device === 'mobile'">
          <div class="info-title-wrapper">
                <img class="icon"
                     v-if="checkIfThemeIsActive(availableThemes.Kabel24)"
                     :src="publicImage('themes/kabel24/chevron-down-primary.svg')"
                     alt="chevron_left"
                     :class="getActiveTheme"
                />
                <img v-else class="icon" :src="publicImage('themes/elektramat/arrow-blue-left.svg')" alt=""/>
            <div>
              {{ $t('LeaveDecisionAid.close_and_go_to') }} <strong>{{
                checkIfThemeIsActive(availableThemes.Kabel24)
                  ? $t('global.theme.kabel-24')
                  : $t('global.theme.elektramat')
              }}</strong>
            </div>
          </div>
        </div>

        <StepHeaderMobile v-if="device === 'mobile'"/>
        <StepHeader v-else/>
        <DecisionAid/>
        <PopupConfirm ref="confirm"/>
      </template>
    </div>
  </div>
</template>

<script>
import verge from 'verge';
import DecisionAid from '@/components/DecisionAid';
import StepHeader from '@/components/header/StepHeader';
import EmatLoader from '@/components/library/EmatLoader';
import StepHeaderMobile from '@/components/header/StepHeaderMobile';
import ErrorPage from '@/components/layout/ErrorPage';
import PopupConfirm from '@/components/PopupConfirm';
import {mapActions, mapGetters, mapMutations} from 'vuex';
import stepBrowserHistory from "@/mixins/stepBrowserHistory";

export default {
  name: 'App',

  mixins: [stepBrowserHistory],

  components: {
    PopupConfirm,
    ErrorPage,
    StepHeaderMobile,
    StepHeader,
    DecisionAid,
    EmatLoader,
  },

  data() {
    return {
      cssPrefix: process.env.VUE_APP_CSS_PREFIX || 'eda',
      loading: false,
      error: null,
    };
  },

  methods: {
    ...mapMutations([
      'setDevice',
    ]),
    ...mapActions('theme', [
      'initializeTheme',
      'enableHotKeyThemeSwitch',
    ]),
    setResponsiveDevice() {
      const width = verge.viewportW();

      if (width > 1024) {
        this.setDevice('desktop');
      } else if (width > 840) {
        this.setDevice('tablet');
      } else {
        this.setDevice('mobile');
      }
    },

    confirmLeave() {
      if (window.confirm(this.$t('LeaveDecisionAid.all_progress_will_be_lost'))) {
        const url = this.checkIfThemeIsActive(this.availableThemes.Kabel24)
          ? 'https://www.kabel24.nl/'
          : 'https://www.elektramat.nl/';

        window.location.href = url;
      }
    },
  },

  computed: {
    ...mapGetters({
      checkIfThemeIsActive: 'theme/checkIfThemeIsActive',
      getActiveTheme: 'theme/getActiveTheme',
      availableThemes: 'theme/getAvailableThemes'
    }),
    device() {
      return this.$store.getters.getDevice;
    },
  },

  async created() {
    this.initializeTheme();
    if (process.env.NODE_ENV === 'development') {
      this.enableHotKeyThemeSwitch();
    }

    try {
      this.loading = true;
      await this.$store.dispatch('initialize');
      this.loading = false;

      window.addEventListener('resize', this.setResponsiveDevice);
      this.setResponsiveDevice();
    } catch ({ response }) {
      const data = response.data;

      if (response.status === 404 && data.message.includes('App\\Models\\Environment')) {
        this.error = this.$t('global.error.environment_does_not_exist');
        return;
      }

      const exception = data.exception;

      if (exception.endsWith('NoDefaultQuestionException')) {
        this.error = this.$t('global.error.no_first_question');
      } else {
        this.error = this.$t('global.error.something_went_wrong');
      }
    }
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.setResponsiveDevice);
  },
};
</script>

<style lang="scss">
@import 'scss/app';

.eda {
  display: flex;
  flex-direction: column;
  font-family: $font;
  overflow: hidden;
  min-height: 200px;
  background-color: #F9F9F9;
  -webkit-font-smoothing: antialiased;

  @media only screen and (max-width: 840px) {
    min-height: 100vh;
  }
}

.info-banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 36px;
  cursor: pointer;
  background: $white;

  .info-title-wrapper {
    width: 100%;
    display: flex;
    align-items: center;
    padding-left: 17px;
    padding-right: 17px;
    font-family: var(--configurator-font);
    font-size: 12px;

    .icon {
      width: 10px;
      margin-right: 8px;

      &.kabel-24 {
        transform: rotate(90deg);
      }
    }

    strong {
      color: var(--configurator-primary);
    }
  }
}
</style>
